export default __webpack_public_path__ + "static/media/backgroundmobile.afff2fe2.png";